import { defineMessages } from 'react-intl';

export default defineMessages({
  loadError: {
    id: 'app.containers.Splash.loadError',
    defaultMessage: "Splash couldn't load. Try again later.",
    description: 'Shown when the hidden game cannot be downloaded',
  },
  doomLoadError: {
    id: 'app.containers.Splash.doomLoadError',
    defaultMessage: "DOOM couldn't load. Try again later.",
    description:
      'Shown when the DOOM easter egg cannot be downloaded or fails to start',
  },
});
